import { render, staticRenderFns } from "./project-create.vue?vue&type=template&id=a37ad106&scoped=true"
import script from "./project-create.vue?vue&type=script&lang=js"
export * from "./project-create.vue?vue&type=script&lang=js"
import style0 from "./project-create.vue?vue&type=style&index=0&id=a37ad106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37ad106",
  null
  
)

export default component.exports